import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'aoe-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  standalone: false
})
export class PartnersComponent implements OnInit {

  @Input()
  pictureId!: string;

  constructor(
    private readonly sanitize: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

  get pictureLink(): SafeUrl {
    return this.sanitize.bypassSecurityTrustResourceUrl(`${environment.apiUrl}/event/photo/${this.pictureId}/partners`);
  }

}
